import type { i18n as I18nInstance } from "i18next";
import { createI18nInstance, setLanguageMessages } from "./createI18n";
import { loadLocaleMessages } from "./i18n-resources";
import type { LanguageCode } from "./site-config";

const i18n = createI18nInstance("en", {}) as I18nInstance;

export async function initializeBrowserI18n(language: LanguageCode) {
  const [englishMessages, messages] = await Promise.all([
    loadLocaleMessages("en"),
    language === "en" ? Promise.resolve(null) : loadLocaleMessages(language),
  ]);

  setLanguageMessages(i18n, "en", englishMessages);

  if (messages) {
    setLanguageMessages(i18n, language, messages);
  }

  if (i18n.language !== language) {
    await i18n.changeLanguage(language);
  }

  return i18n;
}

export default i18n;
